import React from 'react'
import { message, Modal, Form} from 'antd'
import PermissionList     from '../../../components/Settings/PermissionList'
import BackLink           from '../../../components/Shared/BackLink'
import { colorByRole }    from '../../../components/Settings/UserCard'
import EditPermissionForm from '../../../components/Settings/EditPermissionForm'
import LoadingSpinner     from '../../../components/Shared/LoadingSpinner'
import CloudFlyerAPI         from '../../../api/CloudFlyerAPI'
import { receiveError }   from '../../../api/http'
import './index.scss'

class RoleList extends React.Component {

  constructor() {
    super()

    this.state = {
      loading         : true,
      modalVisible    : false,
      selectedRoleAcl : null,
      roleAcls        : [],
      rolePermissions : [],
      unit            : 1
    }

    this.getRolePermissions        = this.getRolePermissions.bind(this)
    this.toggleRoleAclEnabled      = this.toggleRoleAclEnabled.bind(this)
    this.handleRolePermissionsSave = this.handleRolePermissionsSave.bind(this)
  }

  componentDidMount() {
    CloudFlyerAPI
      .user_account
      .roles
      .acls
      .fetchAll()
      .then(({ data }) => {
        this.setState({roleAcls: data, loading: false})
      })
      .catch(err=>{
        console.error(err)
        message.error(err.message)
      })
  }

  handleError (err) {
    const { message:msg } = receiveError(null, err)
    message.error(msg)
  }

  toggleRoleAclEnabled(roleAclId, enabled) {
    CloudFlyerAPI
      .user_account
      .roles
      .acls
      .toggleEnabled(roleAclId, enabled)
      .then((data) => {
        const roleAcls = this.state.roleAcls.map(role => {
          const acls = role.acls.map(acl => {
            if (acl.id === roleAclId) {
              acl = { ...acl, enabled }
            }
            return acl
          })
          return { ...role, acls }
        })
        this.setState({
          roleAcls
        })
      })
      .catch(this.handleError)
  }

  getRolePermissions(roleAclId) {
    let $this = this
    this.setState({selectedRoleAcl: roleAclId})
    CloudFlyerAPI
      .user_account
      .roles
      .permissions
      .fetchByRoleAcl(roleAclId)
      .then(({data}) => {
        this.setState({
          rolePermissions: data,
          unit:1,
          modalVisible: true
        }, $this.props.form.resetFields)
      })
      .catch(err=>{
        console.error(err)
        message.error(err.message)
      })
  }

  handleRolePermissionsSave() {
    const { selectedRoleAcl, rolePermissions, unit } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        return Promise.all(Object.keys(values).map(id => {
          const [attribute] = Object.keys(values[id])
          return CloudFlyerAPI
            .user_account
            .roles
            .permissions
            .updateOne(selectedRoleAcl, id, {
              attribute,
              value: (values[id][attribute] === 'Unlimited' ? -1 : values[id][attribute]) * unit
            })}))
          .then(() => this.setState({modalVisible: false, selectedRoleAcl: null}))
          .catch(err =>{
            console.error(err)
            message.error(err.message)
          })
      }
    })
  }

  on_unit_change = unit => this.setState({unit})

  render() {
    const {roleAcls, rolePermissions, selectedRoleAcl, modalVisible, loading, unit} = this.state
    const { getFieldDecorator } = this.props.form

    if (loading) return <LoadingSpinner/>

    return (
      <div className="role-list-container">
        <BackLink to='/users' text='Go back to users' />
        <div className="role-list">
          {roleAcls.map((role, index) => (
            <div key={index} className="role-item round-corner">
              <div className="role"
                style={{ backgroundColor: colorByRole[role.title] }}>
                {role.title}
              </div>
              <PermissionList
                acls={role.acls} selectedAcl={selectedRoleAcl}
                getPermissions={this.getRolePermissions}
                toggleAclEnabled={this.toggleRoleAclEnabled} />
            </div>
          ))}
        </div>
        {modalVisible &&
          <Modal
            title='Service Permissions'
            visible={modalVisible}
            onOk={this.handleRolePermissionsSave}
            onCancel={()=>this.setState({ modalVisible: !modalVisible, selectedRoleAcl: null})}>
            <EditPermissionForm
              permissions={rolePermissions}
              unit={unit}
              on_unit_change={this.on_unit_change}
              getFieldDecorator={getFieldDecorator}/>
          </Modal>}
      </div>
    )
  }
}

export default Form.create()(RoleList)
